import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["theme", "cardTitle", "cardTextAlignment", "cardBody", "circleCheck", "cardContentText", "checked", "plusButtonBoolean", "avatarBoolean", "avatarAltText", "avatarImgPath", "dateOfCardText", "imagePath", "imageAltText", "termsAndConditons", "eyebrow", "eyebrowColor", "eyebrowVariant", "eyebrowSx", "eyebrowTextTransform", "focalPointImage", "buttonText", "buttonUrl", "buttonIcon", "buttonIconPosition", "allCards"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CheckCircle, CheckCircleOutline } from '@mui/icons-material';
import { Checkbox, CardContent, Grid, CardMedia, useMediaQuery, Box } from '@mui/material';
import FocalPointImage from '../../templates/FocalPointImage';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import DefaultCardHeader from './DefaultCardHeader';
import OverlineCardHeader from './OverlineCardHeader';
import TAGTypography from '../TAGTypography/TAGTypography';
import { TAGButton } from '../../..';

var DefaultLayout = function DefaultLayout(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? undefined : _ref$theme,
      cardTitle = _ref.cardTitle,
      _ref$cardTextAlignmen = _ref.cardTextAlignment,
      cardTextAlignment = _ref$cardTextAlignmen === void 0 ? 'start' : _ref$cardTextAlignmen,
      cardBody = _ref.cardBody,
      circleCheck = _ref.circleCheck,
      cardContentText = _ref.cardContentText,
      checked = _ref.checked,
      plusButtonBoolean = _ref.plusButtonBoolean,
      avatarBoolean = _ref.avatarBoolean,
      avatarAltText = _ref.avatarAltText,
      avatarImgPath = _ref.avatarImgPath,
      dateOfCardText = _ref.dateOfCardText,
      imagePath = _ref.imagePath,
      imageAltText = _ref.imageAltText,
      termsAndConditons = _ref.termsAndConditons,
      eyebrow = _ref.eyebrow,
      eyebrowColor = _ref.eyebrowColor,
      _ref$eyebrowVariant = _ref.eyebrowVariant,
      eyebrowVariant = _ref$eyebrowVariant === void 0 ? 'bodyMediumBook' : _ref$eyebrowVariant,
      eyebrowSx = _ref.eyebrowSx,
      eyebrowTextTransform = _ref.eyebrowTextTransform,
      focalPointImage = _ref.focalPointImage,
      buttonText = _ref.buttonText,
      buttonUrl = _ref.buttonUrl,
      buttonIcon = _ref.buttonIcon,
      buttonIconPosition = _ref.buttonIconPosition,
      _ref$allCards = _ref.allCards,
      allCards = _ref$allCards === void 0 ? [] : _ref$allCards,
      props = _objectWithoutProperties(_ref, _excluded);

  var brandTheme = useTheme();
  var brandName = brandTheme.palette.brandName;
  var mobileWidth = useMediaQuery('(max-width:600px)');

  var getImageStyles = function getImageStyles() {
    if (!imagePath) {
      return null;
    }

    switch (brandName) {
      case 'aspenDental':
        return {
          height: mobileWidth ? '190px' : '220px'
        };

      case 'motto':
        // to do
        return {
          height: mobileWidth ? '180px' : '160px'
        };

      case 'wellnow':
        return {
          height: mobileWidth ? '190px' : '220px'
        };
    }
  };

  var imageOnTop = theme === 'BigImageOnTop' || theme === 'BigImageOnTopButtons' || theme === 'SmallImageOnTop'; // calculate padding based on the cards

  var cardsThatHasActions = allCards.length ? allCards.filter(function (card) {
    var _card$tc;

    return card.buttonText && card.buttonUrl || (card === null || card === void 0 ? void 0 : (_card$tc = card.tc) === null || _card$tc === void 0 ? void 0 : _card$tc.text);
  }) : [];
  var boxPadding = cardsThatHasActions.length ? '100px' : '20px';
  return React.createElement(React.Fragment, null, imageOnTop ? !focalPointImage ? React.createElement(CardMedia, {
    component: "img",
    image: imagePath,
    alt: imageAltText,
    sx: _objectSpread({}, getImageStyles())
  }) : React.createElement(CardMedia, {
    sx: _objectSpread({}, getImageStyles())
  }, React.createElement(FocalPointImage, _objectSpread({}, focalPointImage))) : null, React.createElement(Box, {
    sx: {
      paddingBottom: boxPadding
    }
  }, React.createElement(Grid, {
    container: true,
    columns: 16
  }, eyebrow && React.createElement(Grid, {
    item: true,
    sx: {
      eyebrowSx: eyebrowSx,
      justifyContent: cardTextAlignment,
      display: 'flex',
      minHeight: '14px',
      padding: '16px 16px 0 16px',
      width: '100%'
    }
  }, React.createElement(TAGTypography, {
    variant: eyebrowVariant === 'overline' ? eyebrowVariant : mobileWidth ? 'bodySmallBook' : 'bodyMediumBook',
    sx: {
      fontSize: '14px',
      lineHeight: '16px',
      textTransform: eyebrowTextTransform,
      color: eyebrowColor
    }
  }, eyebrow)), React.createElement(Grid, {
    item: true,
    xs: circleCheck ? 13 : 16
  }, theme === 'ImageOnRight' ? React.createElement(OverlineCardHeader, {
    cardTitle: cardTitle,
    cardBody: cardBody
  }) : React.createElement(DefaultCardHeader, {
    theme: theme,
    cardTitle: cardTitle,
    cardTextAlignment: cardTextAlignment,
    cardBody: cardBody,
    plusButtonBoolean: plusButtonBoolean,
    avatarBoolean: avatarBoolean,
    avatarAltText: avatarAltText,
    avatarImgPath: avatarImgPath
  })), circleCheck && theme !== 'SmallImageOnTop' ? React.createElement(Grid, {
    item: true,
    xs: 3,
    sx: {
      px: 1,
      py: 2,
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'right'
    }
  }, React.createElement(Checkbox, _objectSpread({
    sx: {
      p: 1.5
    },
    icon: React.createElement(CheckCircleOutline, null),
    checkedIcon: React.createElement(CheckCircle, null),
    checked: checked
  }, props))) : null), theme === 'HeadlineOnTop' ? !focalPointImage ? React.createElement(CardMedia, {
    component: "img",
    image: imagePath,
    alt: imageAltText,
    sx: _objectSpread({}, getImageStyles())
  }) : React.createElement(CardMedia, {
    sx: _objectSpread({}, getImageStyles())
  }, React.createElement(FocalPointImage, _objectSpread({}, focalPointImage))) : null, cardContentText && theme !== 'SmallImageOnTop' && theme !== 'BigImageOnTop' ? React.createElement(CardContent, {
    sx: {
      paddingTop: '0px',
      alignSelf: 'flex-end'
    }
  }, React.createElement(TAGTypography, {
    variant: "bodySmallBook",
    color: "neutrals.secondary"
  }, cardContentText)) : null, theme !== 'BigImageOnTop' && theme !== 'SmallImageOnTop' && buttonText && buttonUrl ? React.createElement(Box, {
    sx: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: '15px 20px 40px 15px',
      textAlign: cardTextAlignment
    }
  }, React.createElement(TAGButton, {
    href: buttonUrl,
    buttonVariant: "Tertiary Default",
    buttonIconPosition: buttonIconPosition,
    buttonIcon: buttonIcon
  }, buttonText)) : null, theme === 'BigImageOnTop' ? React.createElement(TAGTypography, {
    variant: "bodySmallBook",
    sx: [{
      ml: 2,
      mb: '11px'
    }]
  }, dateOfCardText) : null, termsAndConditons && React.createElement(Box, {
    sx: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: '10px',
      padding: '0 0 5px 15px'
    }
  }, React.createElement(Grid, {
    item: true,
    sx: {
      textAlign: cardTextAlignment
    }
  }, termsAndConditons))));
};

export default DefaultLayout;